module.exports = __webpack_public_path__ + "img/live_pendant.7b0be484.jpg";